import { render, staticRenderFns } from "./pos.vue?vue&type=template&id=318bbb9d&scoped=true&"
import script from "./pos.vue?vue&type=script&lang=js&"
export * from "./pos.vue?vue&type=script&lang=js&"
import style0 from "./pos.vue?vue&type=style&index=0&id=318bbb9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318bbb9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318bbb9d')) {
      api.createRecord('318bbb9d', component.options)
    } else {
      api.reload('318bbb9d', component.options)
    }
    module.hot.accept("./pos.vue?vue&type=template&id=318bbb9d&scoped=true&", function () {
      api.rerender('318bbb9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firm/pos.vue"
export default component.exports